(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteTranslationProperty', PublicSiteTranslationProperty);

    PublicSiteTranslationProperty.$inject = ['$resource'];

    function PublicSiteTranslationProperty ($resource) {
        var resourceUrl =  'api/public-site-translation-properties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
